import { doCheckOffers } from "../../../../../logics/src/utils/checkOffers";
import { getOfferMessages } from "../../../../../logics/src/utils/helpers";
import { INetBankingDetails } from "@nykaa/payment-sdk/src/Payment/@types";
import { PAYMENT_MODES } from "constants/paymentModes";
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import { toLowerCase } from "helpers/utils/toLowerCase";
import { getStringFromId } from "helpers/vernacular";
import { getPlatform } from "../../../../../helpers/index";
import { ISavedNetBanking, OfferDataInterface } from "../@types/savedMethods";
import { getBankImage } from "layouts/Payment/PaymentMethods/helpers";
import { BUTTON_TYPE } from "constants/index";
import { formatNumber } from "helpers/utils/numberFormatter";

export const getSavedNbContextData = ({
    paymentContext,
    orderAmount: grandTotal,
    doPayment,
    toggleOfferBottomSheet,
    strikedPaymentText,
    theme,
}:any)=>{

    const platform = getPlatform();
    const cartRules = paymentContext?.offersData;
    const paymentInfo = paymentContext?.paymentInfo;
    const cartInfo = paymentContext?.cartInfo;
    const initialOrderAmount = cartInfo?.grandTotal;


    let selectedBank = {
        name: '',
        payuCode: '',
    };
    let config = {};
    const lastPaymentInfo = paymentInfo?.lastPaymentInfo;
    const netBankingList = paymentInfo?.netBankingList;
    if (!lastPaymentInfo) return {} as ISavedNetBanking;

    const savedIssuerBank = lastPaymentInfo?.issuerBank;
      
    const title = getStringFromId(
    VERNACULAR_STRING_IDS.NETBANKING_TITLE,
    VERNACULAR_DEFAULT_MESSAGES.NETBANKING_TITLE
    );

    const payNowText = getStringFromId(
    VERNACULAR_STRING_IDS.DYNAMIC_PAY,
    `Pay ₹${formatNumber(grandTotal)}`,
    { count: grandTotal }
    );

    
    const savedPaymentId = lastPaymentInfo?.paymentInfo;
    if (savedPaymentId)
    selectedBank = {
        name: savedIssuerBank,
        payuCode: savedPaymentId,
    };
    
    const offerKeys = lastPaymentInfo?.offerKeys || [];
    let offerMessages:any = [];
    let revisedBtnText = strikedPaymentText;
    let offerData  = {} as OfferDataInterface;
    let offerDetailConfig = {};
    let offers: any[] = [];
    if (offerKeys?.length) {
        offerKeys.forEach((offerKey: string) => {
            let offer: PaymentOfferRule[] = cartRules.paymentRules.filter(
                (rule: PaymentOfferRule) => rule.ruleKey === offerKey
            );
            offers.push(offer);
            offers = offers.flat();
        });
        if (offers?.length > 1) {
            offers = offers.sort((a: PaymentOfferRule, b: PaymentOfferRule) => b?.priority - a?.priority);
        }

        if (offers?.length) {
            const keys = offers.map((offer) => offer?.ruleKey);
            offerData = doCheckOffers(
                false,
                PAYMENT_MODES.NET_BANKING,
                cartRules,
                paymentInfo,
                keys
            );
            if (offerData?.hasOffers && offerData?.finalOrderAmount) {
                offerMessages = getOfferMessages(
                    offerData,
                    theme,
                    () => toggleOfferBottomSheet(offerData) 
                );

                revisedBtnText = getStringFromId(
                VERNACULAR_STRING_IDS.DYNAMIC_PAY_WITH_STRIKED_AMOUNT,
                `Pay ₹${formatNumber(offerData?.finalOrderAmount)} &nbsp; <del> ₹${formatNumber(initialOrderAmount)}</del>`,
                {
                    oldAmount: initialOrderAmount,
                    newAmount: offerData?.finalOrderAmount || '',
                }
                );
            }
        }
    }
    
    config = {
        title,
        subTitle: savedIssuerBank,
        leadingIcon: getBankImage(toLowerCase(savedIssuerBank)),
        alert: {
        leadingIcon: getIcons(platform, ICONS_NAMES.WARN_ICON),
        warn: true,
        text: '',
        },
        doPayment: () => {
        // Required for adding Money to wallet and giftcard purchase
        // isSavedNb -- passed as payload for savedNb is different than unsavedNb
        doPayment(PAYMENT_MODES.NET_BANKING,{ mode: PAYMENT_MODES.NET_BANKING, selectedBank, offerData, grandTotal, isSavedNb: true, isSaved:true });
        },
        payNowText: grandTotal ? payNowText : '',
        revisedPayNowText: revisedBtnText,
        offerMessages: offerMessages,
        pymentMethod: PAYMENT_MODES.NET_BANKING,
        offerDetailConfig,
        priority: 0,
        theme,
        buttonType: BUTTON_TYPE.MEDIUM,
    };

    return config as ISavedNetBanking;
}